import {
  DEFAULT_SPEED_CURVE_SETTINGS,
  SPEED_COLOR_STOPS,
  getSpeedCurveSettings
} from './speedCurveSettings'

export function parsePointSpdKm(point) {
  if (!point || typeof point !== 'object') return 0
  const raw =
    point.spd != null && point.spd !== ''
      ? point.spd
      : point.spdNum != null && point.spdNum !== ''
        ? point.spdNum
        : point.speed != null && point.speed !== ''
          ? point.speed
          : 0
  const n = Number(raw)
  return Number.isFinite(n) ? n : 0
}

export function getSpeedRangeColor(speed, settings) {
  const cfg = settings || getSpeedCurveSettings()
  const nodes = cfg.speedNodes || DEFAULT_SPEED_CURVE_SETTINGS.speedNodes
  const s = Number(speed) || 0
  if (s <= nodes[0]) return SPEED_COLOR_STOPS[0]
  if (s <= nodes[1]) return SPEED_COLOR_STOPS[1]
  return SPEED_COLOR_STOPS[2]
}

/** 轨迹点 → 按速度着色的折线段（相邻同色段合并）；pointStartIndex 为 traceList 下标 */
export function buildSpeedColoredSegments(points, settings) {
  if (!Array.isArray(points) || points.length < 2) return []
  const cfg = settings || getSpeedCurveSettings()
  const segments = []
  for (let i = 0; i < points.length - 1; i++) {
    const a = points[i]
    const b = points[i + 1]
    const lon1 = Number(a && a.lon)
    const lat1 = Number(a && a.lat)
    const lon2 = Number(b && b.lon)
    const lat2 = Number(b && b.lat)
    if (![lon1, lat1, lon2, lat2].every(Number.isFinite)) continue
    const color = getSpeedRangeColor(parsePointSpdKm(a), cfg)
    const last = segments[segments.length - 1]
    if (last && last.color === color && last.pointEndIndex === i) {
      last.path.push([lon2, lat2])
      last.pointEndIndex = i + 1
    } else {
      segments.push({
        path: [[lon1, lat1], [lon2, lat2]],
        color,
        pointStartIndex: i,
        pointEndIndex: i + 1
      })
    }
  }
  return segments
}
